import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

export type TTaskForm = {
  name: string
  startTime: Date
  selectedDate: Date
  duration: number
  permitNeeded: number
  needsEquipmentRental: boolean
  isBreakIn: boolean
  isComplete: boolean
  operationPostId?: number | undefined
  permitTypeIds?: number[] | undefined
  permitStatus?: number | undefined
}

export function useTaskForm() {
  function getResolvedValidationSchema() {
    const validationSchema = z
      .object({
        name: z.string().min(1, { message: 'Please, add a Task name' }),
        startTime: z.date(),
        selectedDate: z.date(),
        duration: z
          .union([z.string(), z.number()])
          .transform((val) =>
            String(val).length === 0 ? '' : val === '0' ? 0 : Number(val),
          )
          .refine((val) => typeof val !== 'string', {
            message: 'Please, add the duration for this task',
          })
          .refine((val) => Number(val) > 0, {
            message: 'Value must be greater than 0',
          }),
        operationPostId: z.number().optional(),
        permitTypeIds: z.number().array().optional(),
        permitStatus: z.number().optional(),
        permitNeeded: z.number(),
        needsEquipmentRental: z.boolean(),
        isBreakIn: z.boolean(),
        isComplete: z.boolean(),
      })
      .superRefine((data, ctx) => {
        if (data.permitNeeded === 1 && data.permitTypeIds === undefined) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'At least one Permit Type must be selected',
            path: ['permitTypeIds'],
          })
        }
      })
      .superRefine((data, ctx) => {
        if (data.permitNeeded === 1 && data.permitStatus === undefined) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'At least one Permit Status must be selected',
            path: ['permitStatus'],
          })
        }
      })

    return zodResolver(validationSchema)
  }

  return { getResolvedValidationSchema }
}
